// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import '../styles/warning.css';

export default class Warning extends React.Component {

    render = () => {

        return (
            <div className='warning-container'>
                <div className='warning-content'>
                    <h3 className='warning-title'>{this.props.title}</h3>
                    <p className='warning-message'>{this.props.message}</p>
                </div>
            </div>
        )

    }

}